<template>
  <div class="bdw">
    <div class="bdw-head">
      <span class="bdw-head__bar" />
      <span class="bdw-head__title">截止预警</span>
      <span class="bdw-head__badge">{{ data.total || 0 }} 项临近</span>
    </div>
    <div class="bdw-body">
      <div
        v-for="(item, i) in displayList"
        :key="item.id || i"
        class="bdw-row"
        :class="rowClass(item)"
        @click="item.id && goWork()"
      >
        <span class="bdw-row__time">{{ item.id ? rowTime(item) : '' }}</span>
        <span class="bdw-row__dot" />
        <div class="bdw-row__main">
          <div class="bdw-row__text">{{ item.name || '—' }}</div>
          <div v-if="item.id" class="bdw-row__sub">
            <span>{{ formatAmount(item.amount) }}</span>
            <span class="bdw-row__left">剩 {{ item.days_left }} 天</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {USE_MOCK, formatAmount, mockDeadlines} from './bid-dashboard-mock';
import {FEED_SIZE} from './bid-dashboard-theme';

export default {
  data() {
    return {data: {total: 0, list: []}};
  },
  computed: {
    displayList() {
      const list = (this.data.list || []).slice(0, FEED_SIZE);
      while (list.length < FEED_SIZE) list.push({});
      return list;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    formatAmount,
    loadData() {
      if (USE_MOCK) {
        this.data = mockDeadlines();
        return;
      }
      this.$api.get('/business/bid/dashboard/deadline-warnings', {limit: FEED_SIZE}).then((res) => {
        this.data = res.data.data;
      }).catch(() => {
        this.data = mockDeadlines();
      });
    },
    formatDate(d) {
      return d ? moment(d).format('MM/DD') : '';
    },
    rowTime(item) {
      return this.formatDate(item.bid_deadline);
    },
    rowClass(item) {
      if (!item.id) return 'bdw-row--empty';
      if (item.days_left <= 1) return 'bdw-row--urgent';
      if (item.days_left <= 3) return 'bdw-row--warn';
      return '';
    },
    goWork() {
      const base = this.$route.path.replace(/\/[^/]+$/, '');
      this.RouteTo(`${base}/work`);
    },
  },
};
</script>

<style lang="less" scoped>
.bdw {
  height: 100%;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #fecaca;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.bdw-head {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: #fef2f2;
  border-bottom: 1px solid #fee2e2;
  flex-shrink: 0;
}

.bdw-head__bar {
  width: 3px;
  height: 11px;
  background: #ef4444;
  border-radius: 2px;
}

.bdw-head__title {
  font-size: 13px;
  font-weight: 700;
  color: #b91c1c;
}

.bdw-head__badge {
  margin-left: auto;
  font-size: 12px;
  color: #ef4444;
  font-weight: 600;
}

.bdw-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 2px 0;
}

.bdw-row {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border-bottom: 1px dashed #fee2e2;
  cursor: pointer;
  min-height: 0;

  &:last-child { border-bottom: none; }
  &:hover:not(&--empty) { background: #fef2f2; }
  &--empty { opacity: 0.25; cursor: default; }

  &--warn .bdw-row__text { color: #c2410c; }
  &--warn .bdw-row__dot { background: #f97316; }

  &--urgent .bdw-row__text { color: #b91c1c; font-weight: 700; }
  &--urgent .bdw-row__dot { background: #ef4444; box-shadow: 0 0 4px rgba(239, 68, 68, 0.5); }
  &--urgent .bdw-row__left { color: #ef4444 !important; }
}

.bdw-row__time {
  width: 36px;
  flex-shrink: 0;
  font-size: 10px;
  color: #ef4444;
  text-align: right;
  font-weight: 600;
}

.bdw-row__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fca5a5;
  flex-shrink: 0;
}

.bdw-row__main {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.bdw-row__text {
  font-size: 12px;
  font-weight: 600;
  color: #1e3a5f;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.bdw-row__sub {
  flex-shrink: 0;
  font-size: 10px;
  color: #9cb8d8;
  display: flex;
  gap: 6px;

  span:first-child {
    color: #6b8aad;
    font-weight: 600;
  }
}

.bdw-row__left {
  color: #f97316 !important;
  font-weight: 700;
}
</style>
